<template>
  <div>      
    <b-container class="py-4"> 
        <b-input-group class="mt-2 mb-2">
              <b-form-input
                type="text"
                label="Caption"
                v-model="page.caption"
                required
                placeholder="Заголовок страницы"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="changeCaption()" title="Изменить заголовок">
                  <b-icon icon="pencil"></b-icon>
                </b-button>
              </b-input-group-append>
            </b-input-group>
    <quill-editor v-if="page.text!=null" v-model="page.text"
                ref="myQuillEditor"
                :options="editorOption"
                @ready="onEditorReady($event)">
    </quill-editor>        
      <b-button class="mt-1" @click="changePage()">Сохранить</b-button>

      <h4 class="mt-5" v-if="page.fileDetails && page.fileDetails.length>0">Документы</h4>
        <div class="doc-list">
             <div v-for="(document,index) in page.fileDetails" :key="index" class="doc">
          <b-button variant="danger" @click="deletedoc(document.id)" title="Удалить документ">
              <b-icon icon="x"></b-icon>
          </b-button>    
          <a :href="download(document.id,'download')" download>
              <b-button variant="secondary"  title="скачать документ">
                <b-icon icon="download"></b-icon>
              </b-button> 
          </a>
          <div class="doc-name">
              {{document.text}} ( {{document.originalname}} )
          </div>                  
      </div>
        </div>
     

      <h4 class="mt-5">Добавить документ</h4>
      <b-form inline>
        <b-input-group class="w-50">        
          <b-form-input
            type="text"
            label="Docname"
            v-model="newdocument.name"
            required
            placeholder="Название документа"
          ></b-form-input>
        </b-input-group>
        <b-input-group class="mt-2 mb-2 w-50">
          <b-form-file placeholder="файл не выбран" id="filedata" ref="file" @change="handleFileUpload"></b-form-file>
          <b-button variant="secondary" @click="addDoc()" title="Добавить документ">
          <b-icon icon="file-earmark-plus"></b-icon>
        </b-button>
        </b-input-group>
        
      </b-form>
    </b-container>
    <b-toast
      :title="toast.title"
      v-model="toast.show"
      :variant="toast.variant"
      autoHideDelay="5000"
    >{{ toast.message }}</b-toast>
  </div>
</template>
<script>
import Authentication from "@/components/pages/Authentication";
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css' 
import { quillEditor } from 'vue-quill-editor'
import Quill from 'quill'
import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import VideoResize from 'quill-video-resize-module'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
Quill.register('modules/VideoResize', VideoResize);

var Block = Quill.import('blots/block');

class Col2Block extends Block{    
    static blotName = 'col2';
    static tagName = 'div';

    static create(){
        let node = super.create();
        node.setAttribute('class','col2');
        return node;    
    } 
}
Quill.register(Col2Block);


class Col3Block extends Block{    
    static blotName = 'col3';
    static tagName = 'div';
    static create(){
        let node = super.create();
        node.setAttribute('class','col3');
        return node;    
    } 
}

Quill.register(Col3Block);

class Col4Block extends Block{ 
    static blotName = 'col4';
    static tagName = 'div';
    static create(){
        let node = super.create();
        node.setAttribute('class','col4');
        return node;    
    } 
}
Quill.register(Col4Block);

class Col5Block extends Block{ 
    static blotName = 'col5';
    static tagName = 'div';
    static create(){
        let node = super.create();
        node.setAttribute('class','col5');
        return node;    
    } 
}
Quill.register(Col5Block);



let Embed = Quill.import('blots/embed');
class BreakBlock extends Embed {}
BreakBlock.blotName = 'br';
BreakBlock.tagName = 'br';
Quill.register(BreakBlock);

const fontSizeArr = ['10px','12px','14px','16px','18px','20px','24px','32px','42px','54px','68px','84px','98px'];

var Size = Quill.import('attributors/style/size');
Size.whitelist = fontSizeArr;
Quill.register(Size, true);


export default {
  data() {
    return {
      page: {
          text:null
      },
      newdocument:{
          name:'',
          filedata:'',
          alias:this.alias
      },
      editorOption: {
        debug:false,
        modules: {
            toolbar:{container:[
                [{ 'size': fontSizeArr }],
          [ 'bold', 'italic', 'underline', 'strike' ],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'script': 'super' }, { 'script': 'sub' }],
          [{ 'header': '1' }, { 'header': '2' }, 'blockquote', 'code-block' ],
          [{ 'list': 'ordered' }, { 'list': 'bullet'}, { 'indent': '-1' }, { 'indent': '+1' }],
          [ {'direction': 'rtl'}, { 'align': [] }],
          [ 'link', 'image', 'video', 'formula' ],
          ['col2','col3','col4','col5'],
          ['br'],
          [ 'clean' ]
            ],
            handlers: {
                'br': function () {                            
                        var range = this.quill.getSelection();
                        if (range) {
                            this.quill.insertEmbed(range.index,"br","null")
                        }
                    }
                }
            },
            imageDrop: true,
            imageResize: true,   
            VideoResize:true         
        },        
        theme: 'snow'
      },
      toast: {
        show: false,
        title: "",
        variant: "",
        message: "",
      },
    };
  },
  props:['alias'],
  components: {
    quillEditor
  },
  created() {
    this.getPage();
  },
  methods: {  
    onEditorReady(quill){
        quill.container.firstChild.innerHTML = this.page.text
    },  
    showToast(data) {
      if (data) {
        if (data.success) {
          this.toast = {
            show: true,
            title: "Выполнено",
            variant: "success",
            message: data.message,
          };
        } else {
          this.toast = {
            show: true,
            title: "Ошибка",
            variant: "danger",
            message: data.message,
          };
        }
      }
    },
    async getPage() {        
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/pageadmin",
        "post",
        { alias: this.alias }
      );
      if (data) {
        this.page = data;
        console.log(this.page)
      }
    },
    async changePage() {
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/changepage",
        "post",
        this.page
      );
      this.showToast(data);
    },
    async changeCaption() {
      let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/changepagecaption",
        "post",
        this.page
      );
      this.showToast(data);
      this.$router.go()
    },

    async addDoc(){
       if(this.newdocument.name!='' && this.newdocument.filedata!=''){ 
       let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/adddocument",
        "post",
        this.newdocument
      );
      this.showToast(data);
      this.getPage()
      this.newdocument.name=''
      this.newdocument.filedata=''
      this.$refs['file'].reset()    
       }else{
           if(this.newdocument.filedata==''){
               this.showToast({success:false,message:'не добавлен файл'});
           }
           if(this.newdocument.name==''){
               this.showToast({success:false,message:'не заполнено наименование файла'});
           }           
       }  
    },
    download(id,download=false){
        return Authentication.download(id,download)
    }, 
    async deletedoc(id){
       let { data } = await Authentication.sendRequest(
        this,
        "/api/v1/deletedoc/"+id,
        "post"
      );
      this.showToast(data);
      this.getPage()
    },
    handleFileUpload(event){
        if(event.target.files.length>0){
            this.newdocument.filedata = event.target.files[0];
        }else{
            this.newdocument.filedata =''
        }
        
    }
  },
};
</script>
<style lang="scss">
.html-view{
    border: 1px solid #ccc;
}

.ql-container{
    font-size: 16px;
}
.col4 {
    display: inline-block;
    width:calc(100% / 4);
    vertical-align: top;
    margin-bottom: 15px;
}

.col5 {
    display: inline-block;
    width:calc(100% / 5);
    vertical-align: top;
    margin-bottom: 15px;
}

.col3 {
    display: inline-block;
    width:calc(100% / 3);
    vertical-align: top;
    margin-bottom: 15px;
}

.col2 {
    display: inline-block;
    width:calc(100% / 2);
    vertical-align: top;
    margin-bottom: 15px;
}

.ql-col5:after {
  content: "\2630 5";
}

.ql-col4:after {
  content: "\2630 4";
}
.ql-col3:after {
  content: "\2630 3";
}
.ql-col2:after {
  content: "\2630 2";
}


@media (max-width:768px){
    .col2 {
        width:100%;
    }
    .col3 {
        width:calc(100% / 2);
    }
    .col4 {
        width:calc(100% / 2);
    }
    .col5 {
        width:calc(100% / 3);
    }
}
@media (max-width:420px){
    .col3 {
        width:100%;
    }
    .col4 {
        width:100%;
    }
    .col5 {
        width:calc(100% / 2);
    }
}

.ql-br:after {
  content: "\21B5";
}


.ql-snow{
.ql-picker{
    &.ql-size{
        .ql-picker-label,
        .ql-picker-item{
            &::before{
                content: attr(data-value) !important;
            }
        }
    }
}
}

.ql-editor{
    padding:0
}

.page-admin-block{
  .ql-editor{
    padding:10px
}
}

.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
    padding-left: 1em;
}
.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
    padding-left: 2em;
}
.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
    padding-left: 3em;
}
.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
    padding-left: 4em;
}
.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
    padding-left: 5em;
}
.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
    padding-left: 6em;
}
.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
    padding-left: 7em;
}
.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
    padding-left: 8em;
}
.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
    padding-left: 9em;
}
.ql-editor .ql-indent-10:not(.ql-direction-rtl) {
    padding-left: 10em;
}
.ql-editor .ql-indent-11:not(.ql-direction-rtl) {
    padding-left: 11em;
}
.ql-editor .ql-indent-12:not(.ql-direction-rtl) {
    padding-left: 12em;
}
.ql-editor .ql-indent-13:not(.ql-direction-rtl) {
    padding-left: 13em;
}
.ql-editor .ql-indent-14:not(.ql-direction-rtl) {
    padding-left: 14em;
}
.ql-editor .ql-indent-15:not(.ql-direction-rtl) {
    padding-left: 15em;
}

.ql-editor .ql-video{
    display: inline-block;
    margin-right: 10px;
}
.custom-file-input{
    cursor: pointer;
}
.custom-file-label{
    margin: 0;
    border-radius:0 ;
    cursor: pointer;
    content: '';
}

.custom-file-label::after{
    content:'выбрать файл' !important;    
}
.remove-file{
    color: #fff;
    background-color: red;
    cursor: pointer;
}

.doc{
    border-top: 1px solid #ccc;
    border-right: 1px solid #ccc;
    &-name{
        display: inline-block;
        margin-left: 10px;
    }
}

.doc-list .doc:last-child{
    border-bottom: 1px solid #ccc;
}

.page-admin-block .quill-editor iframe {
    pointer-events: none;
}


</style>